import { render, staticRenderFns } from "./wlgl.vue?vue&type=template&id=ba9bd22e&scoped=true&"
import script from "./wlgl.vue?vue&type=script&lang=js&"
export * from "./wlgl.vue?vue&type=script&lang=js&"
import style0 from "./wlgl.vue?vue&type=style&index=0&id=ba9bd22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9bd22e",
  null
  
)

export default component.exports